import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  align-items: flex-start;
  padding: 80px 80px 0px 80px;
  min-height: 100px;

  p {
    margin-top: 16px;
  }

  h2 {
    margin-bottom: 16px;
  }

  @media (max-width: 650px) {
    width: 95%;
    padding: 0px;
    margin-top: 50px;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    p {
      margin-top: 0;
    }

    h2 {
      margin-bottom: 0;
    }
  }
`;

export const ContainerContent = styled.div`
  @media (max-width: 650px) {
    width: 100%;
  }
`;
